/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 23213:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(65665);

/***/ }),

/***/ 89754:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var normalVariation = __webpack_require__(29292);
module.exports = {
  normal: {
    component: normalVariation
  }
};

/***/ }),

/***/ 65665:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var _objectSpread = (__webpack_require__(91903)["default"]);
var _reactJsxRuntime = __webpack_require__(20997);
var React = __webpack_require__(16689);
var _require = __webpack_require__(16689),
  useContext = _require.useContext;
var Variations = __webpack_require__(6996);
var schema = __webpack_require__(89754);
var _require2 = __webpack_require__(31901),
  LandingContext = _require2.LandingContext;
var Title = function Title(_ref) {
  var index = _ref.index,
    component = _ref.component;
  var _useContext = useContext(LandingContext),
    components = _useContext.landingData.components;
  var json = component || components[index];
  return /*#__PURE__*/_jsx(Variations, {
    json: json,
    schema: schema,
    render: function render(_ref2) {
      var Variation = _ref2.Variation;
      return /*#__PURE__*/_jsx("div", {
        className: "hub__boxed-width container-title"
      }, void 0, /*#__PURE__*/_reactJsxRuntime.jsx(Variation, _objectSpread({}, json.data)));
    }
  });
};
Title.defaultProps = {
  component: null
};
module.exports = Title;

/***/ }),

/***/ 29292:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _jsx = (__webpack_require__(90029)["default"]);
var React = __webpack_require__(16689);
var Normal = function Normal(_ref) {
  var title = _ref.title,
    lead = _ref.lead;
  return /*#__PURE__*/_jsx("div", {
    className: "content"
  }, void 0, /*#__PURE__*/_jsx("h1", {
    className: "text__title"
  }, void 0, title), lead && /*#__PURE__*/_jsx("p", {
    className: "text__lead"
  }, void 0, lead));
};
module.exports = Normal;

/***/ }),

/***/ 90029:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/jsx");

/***/ }),

/***/ 91903:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectSpread2");

/***/ }),

/***/ 31901:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/context");

/***/ }),

/***/ 6996:
/***/ ((module) => {

"use strict";
module.exports = require("@splinter/variations");

/***/ }),

/***/ 16689:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 20997:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module used 'module' so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(23213);
/******/ 	module.exports = __webpack_exports__;
/******/ 	
/******/ })()
;
//# sourceMappingURL=index.production.js.map